import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useErrorHandler } from 'react-error-boundary';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import utc from 'dayjs/plugin/utc';

// import '../../css/common2.css';
// import '../../css/style2.css';

import { createDisplayDate, dispTellStartPeople } from '../../utils';
import rsvSettingMasta from '../../api/masta/rsvSettingMasta';

import { ReserveHeader } from '../../components/Header';
import { Footer } from '../../components/Footer';

import { useDidMount } from '../../customHooks';
import changeOrCancelApi from '../../api/reserveChange/changeOrCancel';
import rsvScnMastaApi from '../../api/masta/rsvScnMasta';
import { saveRsvMode, saveTopicPath, saveConfig, saveLocationSetting } from '../../redux_toolkit/rsvConfigSlice';

import {
  saveBusiness,
  saveLgCd,
  saveTimearea,
  saveOldIds,
  saveUrl,
  saveSendType,
  savePlace,
  saveBusinessChangeMode,
  saveBusinessChanged,
  saveNumOfAttendees,
  saveOriginalRecItem,
} from '../../redux_toolkit/reserveChangeSlice';
import changeConfirmation from '../../api/reserveChange/changeConfirmation';

import { PURPOSE_RSV_CANCEL, PURPOSE_RSV_CHANGE, RSV_FLAG_PHONE, CANCEL_CHANGE_ANNOUNCE, DEFAULT_HOME_USE_LABEL } from '../../constants';

dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.locale('ja');

const ChangeOrCancel = function () {
  const dispatch = useDispatch();
  const reserveChange = useSelector((state) => state.reserveChange);
  const rsvConfig = useSelector((state) => state.rsvConfig);
  const homeUseLabel = rsvConfig.locationSetting?.item_label?.home_use || DEFAULT_HOME_USE_LABEL;

  // urlパラメータの取得
  const params = useParams();
  const changeUrl = params.changeUrl ?? reserveChange.url;

  // 画面遷移のためのもの
  const navigate = useNavigate();

  const handleError = useErrorHandler();

  const [stateReceptionId, setReceptionId] = useState('');
  const [stateLgCd, setLgCd] = useState('');
  const [stateRsvNumber, setRsvNumber] = useState('');
  const [stateRsvDate, setRsvDate] = useState('');
  const [statePlaceName, setPlaceName] = useState('');
  const [statePlaceAddress, setPlaceAddress] = useState('');
  const [statePlaceSubAddress, setPlaceSubAddress] = useState('');
  const [statePlaceTel, setPlaceTel] = useState('');
  const [stateChLimit, setStateChLimit] = useState(0);
  const [stateChTimes, setStateChTimes] = useState(0);
  const [displayRecItems, setDisplayRecItems] = useState([]);
  const [numOfAttendees, setNumOfAttendees] = useState([]);
  const [rsvMode, setRsvMode] = useState(null);
  const [startTell, setStartTell] = useState(1);
  const [rsvFlag, setRsvFlag] = useState(0);
  const [stateRsvSetId, setStateRsvSetId] = useState('');
  const [stateUseHome, setStateUseHome] = useState(false);

  // Redux から businessChangeMode を読み取る（handleOnClickChange で使用）
  const businessChangeMode = useSelector((state) => state.reserveChange.businessChangeMode);
  /**
   * 予約日の翌日かどうかの判定（予約日を過ぎていればtrueを返す）
   * @param {*} targetDate
   * @returns
   */
  const checkReserveOver = (targetDate) => {
    const today = dayjs().startOf('day');
    const rsvDay = dayjs(targetDate).startOf('day');

    return today.isAfter(rsvDay);
  };

  // 予約設定マスタを取得
  const getRsvSetting = async (rsvSetId) => {
    const response = await changeOrCancelApi.searchReserveSetting(rsvSetId);
    return response;
  };

  // 表示する用件項目の作成
  const createDisplayRecItems = (business, recItems, rsvSetId, formSetId) => {
    const result = [];
    const checkedRecItems = [];
    // const recItems = reserveChange.recItem;
    // const business = reserveChange.business;

    const businessKeys = Object.keys(business);
    for (let i = 0; i < businessKeys.length; i += 1) {
      const nowBusinessKey = businessKeys[i];
      const { businessName = '' } = business[nowBusinessKey];
      const targetRecItems = recItems.filter(
        (item) => parseInt(item.businessId, 10) === parseInt(nowBusinessKey, 10)
      );

      const recItemKeys = Object.keys(targetRecItems);
      if (recItemKeys.length > 0) {
        result.push(<h3>{businessName}</h3>);
      }

      const tmpItems = {};
      for (let j = 0; j < recItemKeys.length; j += 1) {
        const nowRecItem = recItemKeys[j];
        const { groupId, groupName, recItemId, recItemName, businessId, formSetId } =
          targetRecItems[nowRecItem];
        if (!tmpItems[groupId]) {
          tmpItems[groupId] = { groupName, items: [] };
        }
        checkedRecItems.push({
          recItemId,
          recItemName,
          businessId,
          groupId,
          groupName,
          rsvSetId,
          formSetId,
        });

        // tmpItems[groupId].items[recItemId] = <li style={{ marginLeft: '42px' }}>{recItemName}</li>;
        tmpItems[groupId].items[recItemId] = <li style={{ marginLeft: '24px' }}>{recItemName}</li>;
      }

      const items = [];
      Object.keys(tmpItems).map((e) => {
        // items.push(<strong style={{ marginLeft: '18px' }}>■{tmpItems[e].groupName}</strong>);
        items.push(<strong>■{tmpItems[e].groupName}</strong>);
        items.push(<ul key={`item${i}`}>{tmpItems[e].items}</ul>);
      });

      result.push(items);
    }

    setDisplayRecItems(result);

    dispatch(saveBusiness({ business, recItem: checkedRecItems, rsvSetId, formSetId }));
    // 変更前の用件を保存（ChangeBusiness での businessChanged 判定用）
    dispatch(saveOriginalRecItem({ originalRecItem: checkedRecItems }));
  };

  /**
   * 初期処理
   */
  const initialProcess = async () => {
    try {
      const getReception = await changeOrCancelApi.findByChangeUrl(changeUrl);
      const { receptionId, lclGov = '', reserve = '', rsvSetId = '' } = getReception;
      const {
        rsvNumber,
        rsvDate: tmpRsvDate,
        timeareaName,
        rsvFlag,
        rsvChangeNum,
        numOfAttendees,
        sendType,
      } = reserve;

      // 予約設定を取得する
      const { tell_start: tellStart = 1 } = await rsvSettingMasta.getRsvSetting(rsvSetId);

      if (
        getReception.uStat === '3' ||
        getReception.uStat === '4' ||
        getReception.uStat === '5' ||
        checkReserveOver(tmpRsvDate)
      ) {
        navigate('/invalid/redirect');
      }

      // リロード時の処理のために保存
      sessionStorage.setItem('changeUrl', changeUrl);
      sessionStorage.setItem('lgCd', lclGov.lgCd);
      dispatch(saveLgCd({ lgCd: lclGov.lgCd }));

      // 予約設定の取得
      const { rsvChangeLimit: changeLimit = 0, rsvMode = null } = await getRsvSetting(rsvSetId);

      const { counter = '', citizenId = '', receptionPlace = '' } = getReception;
      const { usePlaceId } = counter;
      const { placeId = '' } = receptionPlace;

      // placeIdは自宅のplace_idなのでplaceId === usePlaceIdの場合は自宅での予約
      const useHome = placeId === usePlaceId;
      setStateUseHome(useHome);

      const getPlace = await changeOrCancelApi.findByUsePlaceId(usePlaceId);
      const { placeName = '', placeAddress = '', placeSubAddress = '', placeTel = '' } = getPlace;
      setPlaceName(placeName);
      setPlaceAddress(placeAddress);
      setPlaceSubAddress(placeSubAddress);
      setPlaceTel(placeTel);

      setReceptionId(receptionId);
      setLgCd(lclGov.lgCd);
      setRsvNumber(rsvNumber);
      setRsvDate(tmpRsvDate);
      setStateChLimit(changeLimit);
      setStateChTimes(rsvChangeNum);
      setNumOfAttendees(numOfAttendees);
      setRsvMode(rsvMode);
      setStartTell(tellStart);
      setRsvFlag(rsvFlag);
      setStateRsvSetId(rsvSetId);

      // business_change_mode と locationSetting を取得して Redux に保存
      const { businessChangeMode: mode = 0, locationSetting: fetchedLocationSetting = {} } = await changeConfirmation.searchReserveSetting(
        rsvSetId,
        lclGov.lgCd
      );
      dispatch(saveBusinessChangeMode({ businessChangeMode: mode }));
      dispatch(saveLocationSetting({ locationSetting: fetchedLocationSetting }));

      // 同席者数を Redux に保存（ChangeForm で前回値として使用）
      dispatch(saveNumOfAttendees({ numOfAttendees: numOfAttendees ?? 0 }));

      dispatch(saveOldIds({ receptionId, citizenId }));
      dispatch(
        savePlace({
          id: usePlaceId,
          name: placeName,
          address: placeAddress,
          subAddress: placeSubAddress,
          tel: placeTel,
          useHome,
          rsvFlag,
        })
      );
      // dispatch(saveLgCd({ lgCd: lclGov.lgCd }));

      // 表示用件の作成
      const { business = {}, recItem = [] } = getReception;
      const { formSetId: initialFormSetId = '' } = recItem[0] ?? {};

      createDisplayRecItems(business, recItem, rsvSetId, initialFormSetId);

      const rsvDate = dayjs(tmpRsvDate).format('YYYY-MM-DD');
      const rsvDateWithTime = dayjs(tmpRsvDate).format('YYYY-MM-DD hh:mm:ss');
      const rsvDayOfWeek = dayjs(tmpRsvDate).format('ddd');

      dispatch(
        saveTimearea({
          timearea: timeareaName,
          rsvDate,
          rsvDateWithTime,
          rsvDayOfWeek,
        })
      );
      dispatch(
        saveUrl({
          url: changeUrl,
        })
      );
      dispatch(
        saveSendType({
          sendType,
        })
      );
    } catch (err) {
      // navigate('/invalid/redirect');
      handleError(err);
    }
  };

  useDidMount(() => {
    // 初期処理
    initialProcess();
  });

  // パンくずの設定
  const settingTopicPath = async (mode, purpose) => {
    try {
      let newTopicPathList = []
      const rsvScnList = await rsvScnMastaApi.getRsvScn(mode, purpose);
      const topicPathList = rsvScnList.map((obj) => ({
        url: obj.rsv_url,
        scnName: obj.scn_name,
      }));
      if (businessChangeMode === 1) {
        newTopicPathList = [...topicPathList]
      }
      if (businessChangeMode === 2) {
        // ③: 用件選択・利用場所選択をスキップ
        const newArray = topicPathList.filter(
          (item) => item.url !== 'change/business'
        );
        newTopicPathList = [...newArray]
      }
      if (businessChangeMode === 3) {
        let removeList = []
        if (topicPathList.length === 6) {
          removeList = [1, 4]
        } else {
          removeList = [1, 5]
        }
        const newArray = topicPathList.filter((_, index) => !removeList.includes(index));
        newTopicPathList = [...newArray]
      }


      dispatch(saveRsvMode({ rsvMode: mode }));
      dispatch(saveTopicPath({ topicPath: newTopicPathList }));
    } catch (err) {
      window.alert('予約受付設定の取得に失敗しました。');
      handleError(err);
    }
  };

  const handleOnClickChange = async () => {
    if (stateChLimit <= stateChTimes) {
      alert(
        `予約変更回数の上限に達しています。\n${stateChLimit + 1}回以上の予約変更はできません。`
      );
      return;
    }

    if (businessChangeMode === 2) {
      // モード②(=2): ChangeBusiness をスキップ。利用場所選択(ChangePlace)は通る。
      // topicPath・rsvConfig を ChangeBusiness の代わりにここで設定する
      const rsvScnList = await rsvScnMastaApi.getRsvScn(rsvMode, PURPOSE_RSV_CHANGE);
      // モード②では用件選択画面のみスキップ（利用場所選択は残す）
      const topicPathList = rsvScnList
        .map((obj) => ({
          url: obj.rsv_url,
          scnName: obj.scn_name,
        }))
        .filter((item) => item.url !== 'change/business');

      const rsvSettingFull = await rsvSettingMasta.getRsvSetting(stateRsvSetId);
      const {
        rsv_mode: skipMode = null,
        max_attendees: maxAttendees = 0,
        rsv_place: rsvPlaceIds = [],
        rsv_tell_place: rsvTelPlaceIds = [],
        tell_start: telStart = 3,
      } = rsvSettingFull;

      dispatch(
        saveConfig({
          rsvMode: skipMode ?? rsvMode,
          topicPath: topicPathList,
          maxAttendees,
          rsvPlaceIds,
          rsvTelPlaceIds,
          telStart,
        })
      );
      dispatch(saveBusinessChanged({ businessChanged: false }));

      // モード②は利用場所選択へ進む
      navigate('/change/place');

      await settingTopicPath(rsvMode, PURPOSE_RSV_CHANGE);
    } else if (businessChangeMode === 3) {
      // モード③(=3): ChangeBusiness と ChangePlace の両方をスキップ。既存の用件・rsvSetId をそのまま維持する。
      // topicPath・rsvConfig を ChangeBusiness の代わりにここで設定する
      const rsvScnList = await rsvScnMastaApi.getRsvScn(rsvMode, PURPOSE_RSV_CHANGE);
      // モード③では用件選択・利用場所選択画面の両方をスキップするため topicPath から除外
      const topicPathList = rsvScnList
        .map((obj) => ({
          url: obj.rsv_url,
          scnName: obj.scn_name,
        }))
        .filter((item) => item.url !== 'change/business');

      const rsvSettingFull = await rsvSettingMasta.getRsvSetting(stateRsvSetId);
      const {
        rsv_mode: skipMode = null,
        max_attendees: maxAttendees = 0,
        rsv_place: rsvPlaceIds = [],
        rsv_tell_place: rsvTelPlaceIds = [],
        tell_start: telStart = 3,
      } = rsvSettingFull;

      dispatch(
        saveConfig({
          rsvMode: skipMode ?? rsvMode,
          topicPath: topicPathList,
          maxAttendees,
          rsvPlaceIds,
          rsvTelPlaceIds,
          telStart,
        })
      );
      dispatch(saveBusinessChanged({ businessChanged: false }));
      navigate('/change/place');

      await settingTopicPath(rsvMode, PURPOSE_RSV_CHANGE);
    } else {
      // モード①: 通常通り ChangeBusiness へ
      await settingTopicPath(rsvMode, PURPOSE_RSV_CHANGE);
      navigate('/change/business');
    }
  };

  return (
    <>
      <ReserveHeader servCd="reserve" lgCd={stateLgCd} />
      <div id="container">
        {/* topicpath */}
        <main>
          <article>
            <div id="contents">
              <div className="inner">
                <h2>予約の変更・キャンセル</h2>
                <p className="txtCenter mt40 mb10">
                  <strong style={{ fontSize: '20px' }}>予約番号</strong>
                </p>
                <div id="reservation" className="mt0">
                  {stateRsvNumber}
                </div>
                <p className="txtCenter">
                  <strong style={{ fontSize: '20px' }}>予約内容</strong>
                </p>
                <table className="tbl_confirmation noBorder mb40">
                  <tbody>
                    <tr>
                      <th>利用場所</th>
                      <td>
                        {stateUseHome ? (
                          homeUseLabel
                        ) : (
                          <>
                            {statePlaceName}
                            {statePlaceName && statePlaceAddress ? <br /> : null}
                            {`${statePlaceAddress} ${statePlaceSubAddress}`}
                            {statePlaceAddress && statePlaceTel ? <br /> : null}
                            {statePlaceTel ? `TEL: ${statePlaceTel}` : ''}
                          </>
                        )}
                        <br />
                        {rsvFlag === RSV_FLAG_PHONE ? dispTellStartPeople(startTell) : null}
                      </td>
                    </tr>
                    <tr>
                      <th>利用日時</th>
                      <td>{createDisplayDate(stateRsvDate, 'YYYY/MM/DD hh:mm')}</td>
                    </tr>
                    {displayRecItems.length === 0 ? null : (
                      <tr>
                        <th>用件</th>
                        <td>{displayRecItems}</td>
                      </tr>
                    )}
                    {numOfAttendees > 0 ? (
                      <tr>
                        <th>同席者数</th>
                        <td>{numOfAttendees}人</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
                <ul id="navi" className="row jcSB spmode mt0">
                  <li className="col2">
                    <a className="btn btLarge" onClick={handleOnClickChange}>
                      予約内容を変更する
                    </a>
                  </li>
                  <li className="col2 mr0 row jcFE">
                    <a
                      className="btn btLarge"
                      onClick={async () => {
                        await settingTopicPath(rsvMode, PURPOSE_RSV_CANCEL);
                        navigate('/change/cancel', {
                          state: {
                            changeUrl,
                            receptionId: stateReceptionId,
                            lgCd: stateLgCd,
                            rsvNumber: stateRsvNumber,
                            placeName: statePlaceName,
                            rsvDate: stateRsvDate,
                          },
                        });
                      }}
                    >
                      予約をキャンセルする
                    </a>
                  </li>
                </ul>
              </div>
              <div className='cancelAnnounce'>{CANCEL_CHANGE_ANNOUNCE}</div>
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default ChangeOrCancel;
